import { AppBar } from "@/components/AppBar";
import { ErrorFallback } from "@/components/ErrorFallback";
import { Footer } from "@/components/Footer";
import { ErrorBoundary } from "@sentry/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_layout/_main")({
  component: () => (
    <>
      <AppBar maxW="8xl" />
      <ErrorBoundary
        fallback={({ error, resetError }) => (
          <ErrorFallback error={error} resetErrorBoundary={resetError} />
        )}
      >
        <Outlet />
      </ErrorBoundary>
      <Footer />
    </>
  ),
});
